import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { LoginWithPin } from './LoginWithPin';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = (user: any, token: string) => {
    // Store the token and user info (using consistent keys)
    localStorage.setItem('authToken', token);
    localStorage.setItem('authUser', JSON.stringify(user));
    // Also store with old keys for backward compatibility
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));

    // Redirect based on user role
    if (user.role === 'admin' || user.userRole === 'admin') {
      navigate('/admin/dashboard');
    } else {
      navigate('/guest');
    }
  };

  const handleBackToLanding = () => {
    console.log('Navigating back to landing page');
    navigate('/');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'var(--gradient-background, linear-gradient(135deg, #667eea 0%, #764ba2 100%))',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header with back button */}
      <Box 
        sx={{ 
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          p: 2,
          zIndex: 10
        }}
      >
        <Button
          startIcon={<ArrowBack />}
          onClick={handleBackToLanding}
          sx={{ 
            color: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.2)'
            }
          }}
        >
          Back to Home
        </Button>
      </Box>

      {/* Login component */}
      <LoginWithPin
        onLoginSuccess={handleLoginSuccess}
        title="Welcome Back"
        subtitle="Enter your email and 4-digit PIN to access your party dashboard"
        onLogoClick={handleBackToLanding}
      />
    </Box>
  );
};